import { useCallback, useEffect, useRef } from "react";

const MENU_ITEM_SELECTOR = '[role="menuitem"]:not([disabled])';

export const usePopoverMenu = (isOpen, setIsOpen) => {
	const triggerRef = useRef(null);
	const menuRef = useRef(null);
	const wasOpenRef = useRef(false);
	const restoreFocusRef = useRef(false);
	const closeMenu = useCallback(
		(restoreFocus = true) => {
			restoreFocusRef.current = restoreFocus;
			setIsOpen(false);
		},
		[setIsOpen],
	);

	useEffect(() => {
		if (!isOpen) {
			if (wasOpenRef.current && restoreFocusRef.current) {
				triggerRef.current?.focus();
			}
			wasOpenRef.current = false;
			restoreFocusRef.current = false;
			return undefined;
		}

		wasOpenRef.current = true;
		restoreFocusRef.current = false;
		menuRef.current?.querySelector(MENU_ITEM_SELECTOR)?.focus();

		const handleMouseDown = (event) => {
			if (!menuRef.current?.contains(event.target)) closeMenu(false);
		};
		const handleFocusIn = (event) => {
			if (!menuRef.current?.contains(event.target)) closeMenu(false);
		};
		const handleKeyDown = (event) => {
			if (event.key !== "Escape") return;
			event.preventDefault();
			closeMenu();
		};

		document.addEventListener("mousedown", handleMouseDown);
		document.addEventListener("focusin", handleFocusIn);
		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("mousedown", handleMouseDown);
			document.removeEventListener("focusin", handleFocusIn);
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [isOpen, closeMenu]);

	return { triggerRef, menuRef, closeMenu };
};
